"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _objectDestructuringEmpty2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectDestructuringEmpty.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _axios = _interopRequireDefault(require("axios"));
var _index = _interopRequireDefault(require("@/components/Store/SalesKPIRecord/index.vue"));
var _TrainingRecords = _interopRequireDefault(require("./components/TrainingRecords"));
var _OtherSales = _interopRequireDefault(require("./components/OtherSales"));
var _TTPSignAesc = _interopRequireDefault(require("./components/TTPSignAesc"));
var _VisitRecord = _interopRequireDefault(require("./components/VisitRecord"));
var _BaseInfo = _interopRequireDefault(require("./components/BaseInfo"));
var _Product = _interopRequireDefault(require("./components/Product"));
var _OtherInfo = _interopRequireDefault(require("./components/OtherInfo"));
var _MoreInfo = _interopRequireDefault(require("./components/MoreInfo"));
var _StoreArchSit = _interopRequireDefault(require("./components/StoreArchSit"));
var _StoreFacEqu = _interopRequireDefault(require("./components/StoreFacEqu"));
var _MainServicesInStore = _interopRequireDefault(require("./components/MainServicesInStore"));
var _StoreInfoPic = _interopRequireDefault(require("./components/StoreInfoPic"));
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/** components */
var _default = exports.default = {
  components: {
    training: _TrainingRecords.default,
    otherSales: _OtherSales.default,
    ttpSignAesc: _TTPSignAesc.default,
    VisitRecord: _VisitRecord.default,
    Product: _Product.default,
    BaseInfo: _BaseInfo.default,
    OtherInfo: _OtherInfo.default,
    MoreInfo: _MoreInfo.default,
    StoreArchSit: _StoreArchSit.default,
    StoreFacEqu: _StoreFacEqu.default,
    MainServicesInStore: _MainServicesInStore.default,
    StoreInfoPic: _StoreInfoPic.default,
    SalesKPIRecord: _index.default
  },
  data: function data() {
    var _this = this;
    var phoneRule = function phoneRule(rule, value, callback) {
      if (value && (0, _validate.validPhone)(value)) {
        callback(new Error(_this.$t('errorValid.validPhone')));
      } else {
        callback();
      }
    };
    var numberRule = function numberRule(rule, value, callback) {
      if (value) {
        if ((0, _validate.isSn)(value)) {
          callback(new Error(_this.$t('retailStoresInfo.error.sn')));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var txtRule = function txtRule(rule, value, callback) {
      // if (value && validRule1(value)) {
      //   callback(new Error(this.$t('retailStoresInfo.error.name')))
      // } else {
      //   callback()
      // }
      // 门店管理和访店报告，文字的字段不加限制
      callback();
    };
    var validateFloat = function validateFloat(rule, value, callback) {
      if (value) {
        if ((0, _validate.isFloat)(value)) {
          callback(new Error(_this.$t('retailStoresInfo.error.float')));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var validateInstoreFac = function validateInstoreFac(rule, value, callback) {
      var _this$form = _this.form,
        laundry = _this$form.laundry,
        restRoom = _this$form.restRoom,
        alignment = _this$form.alignment,
        fitting = _this$form.fitting,
        balancing = _this$form.balancing,
        liftingMachine = _this$form.liftingMachine;
      var hasEmptyValue = [laundry, restRoom, alignment, fitting, balancing, liftingMachine].every(function (v) {
        return v === '' || v == null || v === 'N';
      });
      // if (this.isBailianFlag && hasEmptyValue) {
      if (hasEmptyValue) {
        callback(new Error(_this.$t('errorValid.emptySelect')));
      } else {
        callback();
      }
    };
    var validateProject = function validateProject(rule, value, callback) {
      var _this$form2 = _this.form,
        siBalance = _this$form2.siBalance,
        siWheelPosition = _this$form2.siWheelPosition,
        siTireRepair = _this$form2.siTireRepair,
        siValve = _this$form2.siValve,
        siEngineOil = _this$form2.siEngineOil,
        siBrake = _this$form2.siBrake,
        siFacialClean = _this$form2.siFacialClean,
        siPerishableGoods = _this$form2.siPerishableGoods,
        siOther = _this$form2.siOther;
      var hasEmptyValue = [siBalance, siWheelPosition, siTireRepair, siValve, siEngineOil, siBrake, siFacialClean, siPerishableGoods, siOther].every(function (v) {
        return v === '' || v == null || v === 'N';
      });
      // if (this.isBailianFlag && hasEmptyValue) {
      if (hasEmptyValue) {
        callback(new Error(_this.$t('errorValid.emptyProject')));
      } else {
        callback();
      }
    };
    return {
      isShowProductInfo: false,
      dialogVisible: false,
      dialogImageUrl: '',
      siOther: '',
      routePath: '',
      type: 'view',
      errorKeys: [],
      errorInfo: {},
      rules: {
        /** 只校验正确性 */
        validatePhone: [{
          trigger: ['blur'],
          validator: phoneRule
        }],
        validateNames: [{
          trigger: ['blur'],
          validator: txtRule
        }],
        validateNumbers: [{
          trigger: ['blur'],
          validator: numberRule
        }],
        validateIpt: [{
          trigger: ['blur'],
          validator: txtRule
        }],
        validateFloats: [{
          trigger: ['blur'],
          validator: validateFloat
        }],
        /** 非空校验 */
        isEmpty: [{
          required: true,
          trigger: ['change'],
          message: ' '
        }],
        iptEmpty: [{
          required: true,
          trigger: ['change'],
          message: this.$t('errorValid.empty')
        }],
        phoneEmpty: [{
          required: true,
          trigger: ['change'],
          message: this.$t('errorValid.emptyPhone')
        }],
        chooseEmpty: [{
          required: true,
          trigger: ['change'],
          message: this.$t('errorValid.emptySelect')
        }],
        uploadEmpty: [{
          required: true,
          trigger: ['change'],
          message: this.$t('errorValid.emptyUpload')
        }],
        tyreEighteenGreaterEmpty: [
        // 2.销售情况
        {
          required: true,
          trigger: ['change'],
          message: this.$t('errorValid.empty')
        }],
        siTire: [{
          required: true,
          validator: validateProject,
          trigger: 'change'
        }],
        laundry: [{
          required: true,
          validator: validateInstoreFac,
          trigger: 'change'
        }]
      },
      otherInfoCollapse: true,
      baseInfoCollapse: true,
      moreInfoCollapse: true,
      storeArchSitCollapse: true,
      storeInfoPicCollapse: true,
      mainServicesInStoreCollapse: true,
      storeFacEquCollapse: true,
      otherBrandSalesCollapse: true,
      ttpSignAescCollapse: true,
      isShowTrainingRecordsHideFooter: false,
      isShowVisitRecordHideFooter: false,
      visitRecordList: [],
      isShowVisitRecord: false,
      currentId: null,
      isHideUploadIcon: false,
      isShowTrainingRecords: false,
      showClose: false,
      trainingRecordsList: [],
      isShowProductInfoHideFooter: false,
      retailStoresInfoStatus: [{}],
      isShowSalesKPI: false,
      // 零售店kpi弹窗
      pageName: 'storeDetails',
      formLabelWidth: '120px',
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      lookupList: {
        STORE_RTM_TYPE_MAPPING: {}
      },
      form: {
        PCD: [],
        // 省市区 不传后端
        siTire: '',
        contactsNameTwo: '',
        contactsMobileTwo: '',
        rtlSapId: '',
        rtlRtmId: '',
        rtlFullName: '',
        rtlShortName: '',
        rtlAddress: '',
        rtlAddressExt: '',
        rtlRtmCategory: '',
        rtlRtmCategoryDescription: '',
        rtlRegion: '',
        spRegionCode: '',
        rtlCity: '',
        spCityCode: '',
        rtlDistrict: '',
        spDistrictCode: '',
        contactsNameOne: '',
        contactsMobileOne: '',
        registrationDate: '',
        empNo: '',
        empName: '',
        pointBalance: 0,
        visitFrequency: '',
        lastPurchaseTime: '',
        lastStartTime: '',
        spSapId: '',
        spFullName: '',
        spShortName: '',
        remarkOne: '',
        remarkTwo: '',
        remarkThree: '',
        contactsNameThree: '',
        contactsMobileThree: '',
        customerTireBizYear: '',
        customerTireSob: '',
        monthTireSalesAvg: '',
        storeStructure: '',
        staff: '',
        signBoardBrand: '',
        otherBrand: '',
        installationDate: '',
        dueTime: '',
        photo1: '',
        photo2: '',
        photo3: '',
        siMaintainence: '',
        siFastRepair: '',
        siBeauty: '',
        siWashing: '',
        siOther: '',
        siMain: '',
        siMainPercentage: '',
        area: null,
        workingBay: null,
        laundry: '',
        restRoom: '',
        alignment: '',
        fitting: '',
        balancing: '',
        liftingMachine: '',
        accountingMethod: '',
        tppVo: {},
        isBaiLian: false
      },
      fileList: [],
      startPickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        },
        selectableRange: '00:00:00 - 23:59:59'
      },
      hasErrorTable: false
    };
  },
  computed: {
    // 当前门店是否潜在客户
    isQzkh: function isQzkh() {
      return this.form.rtlRtmCategory === 'potential';
    },
    isBailianFlag: function isBailianFlag() {
      return !!this.form.isBaiLian;
    }
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    },
    '$store.getters.language': function $storeGettersLanguage(newValue) {
      // 监听语言变更重新请求配置查询接口
      this.getLookupTypeCode();
    }
  },
  activated: function activated() {
    this.fetchData();
    this.getLookupTypeCode();
    this.type = 'view';
  },
  methods: {
    updateFormValue: function updateFormValue(v, key, row) {
      row[key] = v;
      // 百炼的校验
      if (this.isBailianFlag) {
        this.$refs.dataForm.validateField(key);
      }
    },
    validTableUnEmpty: function validTableUnEmpty(v) {
      if (this.itemHasVal(v)) {
        this.hasErrorTable = false;
      } else {
        var valid = this.validBailianTable();
        if (!valid) {
          this.hasErrorTable = true;
        } else {
          this.hasErrorTable = false;
        }
      }
    },
    itemHasVal: function itemHasVal(v) {
      return v != null && v !== '';
    },
    validBailianTable: function validBailianTable() {
      var _this2 = this;
      // table里全是空的校验不通过
      return this.form.tireSalesInfos.some(function (item) {
        return _this2.itemHasVal(item.tireSupplier) || _this2.itemHasVal(item.paymentTerms) || _this2.itemHasVal(item.monthlyAvgSales) || _this2.itemHasVal(item.stock);
      });
    },
    validateUpload: function validateUpload(key) {
      this.$refs.dataForm.validateField(key);
    },
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchData: function fetchData() {
      var _this3 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var retailorStoreInfoPk = this.$route.query.retailorStoreInfoPk;
      this.listLoading = true;
      this.$api.retailorStore.getDetails(retailorStoreInfoPk).then(function (res) {
        var _ref = res || {},
          data = _ref.data;
        _this3.listLoading = false;
        _this3.form = data || {};
        // 初始化pcd数据，潜客需要编辑
        var _ref2 = data || {},
          rtlRegionCode = _ref2.rtlRegionCode,
          rtlCityCode = _ref2.rtlCityCode,
          rtlDistrictCode = _ref2.rtlDistrictCode;
        // this.form.PCD = [rtlRegionCode, rtlCityCode, rtlDistrictCode]
        _this3.$set(_this3.form, 'PCD', rtlRegionCode ? [rtlRegionCode, rtlCityCode, rtlDistrictCode] : []);
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this3.listLoading = false;
      });
    },
    getLookupTypeCode: function getLookupTypeCode() {
      var _this4 = this;
      var param = {
        configItemCodeList: ['STORE_SIGN_BRAND_TYPE', 'MAIN_SERVICE_ITEMS', 'DETAILS_ACCOUNTING_METHOD', 'STORE_STRUCTURE', 'STORE_RTM_TYPE', 'TIRE_SUPPLIER', 'ACCOUNTING_METHOD', 'TYRE_BRAND', 'VISIT_PURPOSE',
        // 拜访目的
        'Retailer_Type_description',
        // 零售店类别描述
        'RECORD_FEEDBACK_GOOD', 'RECORD_FEEDBACK_BAD', 'URGENT_DELIVERY_TIME', 'REGULAR_DELIVERY_TIME']
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        _this4.lookupList = JSON.parse(JSON.stringify(res.data || {}));
        // 查找值数据转换
        for (var key in _this4.lookupList) {
          _this4.generateMapping(key, _this4.lookupList[key] || []);
        }
      }).catch(function () {
        console.log('Data Request Fail');
      });
    },
    generateMapping: function generateMapping(title, dataList) {
      var _this5 = this;
      // 将查找值转换成所需数据格式
      this.lookupList["".concat(title, "_MAPPING")] = {};
      dataList.forEach(function (item) {
        var name = item.name,
          code = item.code;
        _this5.lookupList["".concat(title, "_MAPPING")][code] = name;
      });
    },
    saveItem: function saveItem() {
      var _this6 = this;
      this.$refs['dataForm'].clearValidate();
      this.$refs.dataForm.validate(function (valid) {
        var result = true;
        if (_this6.isBailianFlag) {
          result = _this6.validBailianTable();
          if (!result) {
            _this6.hasErrorTable = true;
          } else {
            _this6.hasErrorTable = false;
          }
        }
        if (!valid || !result) {
          return _this6.$message.error(_this6.$t('common.saveErrorMessage'));
        }
        var others = Object.assign({}, ((0, _objectDestructuringEmpty2.default)(_this6.form), _this6.form));
        // 剔除不需要的字段
        // delete others.PCD
        var param = (0, _objectSpread2.default)({}, others);
        _this6.$confirm(_this6.$t('common.confirm14'), _this6.$t('common.tip'), {
          confirmButtonText: _this6.$t('common.confirm'),
          cancelButtonText: _this6.$t('common.cancel'),
          type: 'warning'
        }).then(function () {
          _this6.isLoading = true;
          _this6.$api.retailorStore.saveItem(param).then(function (res) {
            // 保存成功后拉取最新详情数据刷新门店图片更新时间
            _this6.$api.retailorStore.getDetails(_this6.$route.query.retailorStoreInfoPk).then(function (res) {
              var _ref3 = res || {},
                data = _ref3.data;
              _this6.form = data || {};
              // 初始化pcd数据，潜客需要编辑
              var _ref4 = data || {},
                rtlRegionCode = _ref4.rtlRegionCode,
                rtlCityCode = _ref4.rtlCityCode,
                rtlDistrictCode = _ref4.rtlDistrictCode;
              _this6.$set(_this6.form, 'PCD', rtlRegionCode ? [rtlRegionCode, rtlCityCode, rtlDistrictCode] : []);
              _this6.$message.success(_this6.$t('common.updateSuccess'));
              _this6.$set(_this6, 'type', 'view');
              _this6.isLoading = false;
              _this6.isShowModel = false;
            }).catch(function () {
              _this6.isLoading = false;
            });
          }).catch(function (err) {
            if (err.errorInfos && err.errorInfos.length > 0) {
              _this6.resetError();
              err.errorInfos.forEach(function (item) {
                _this6.errorKeys.push(item.key);
                _this6.errorInfo[item.key] = item.errMsg;
              });
              _this6.$refs['dataForm'].validate(function (valid) {
                console.log(valid);
              });
            }
            _this6.isLoading = false;
          });
        }).catch(function () {
          // console.log(err, 'err')
        });
      });
    },
    handleRemove_icon: function handleRemove_icon(file, fileList) {
      var _this7 = this;
      this.fileList = [];
      this.form.noticeImgUrl = '';
      this.form.noticeImgOriginalUrl = '';
      this.imgFormData = null;
      setTimeout(function () {
        _this7.isHideUploadIcon = false;
      }, 500);
    },
    // checkFile1(file, fileList) {
    //   this.imgFormData = file.file
    //   if (this.imgFormData) {
    //     this.isHideUploadIcon = true
    //     this.uploadImg('photo1')
    //   } else {
    //     this.$message.error(this.$t('sfe.notice.error.upload'))
    //     this.isHideUploadIcon = false
    //     this.imgFormData = null
    //   }
    // },
    // checkFile2(file, fileList) {
    //   this.imgFormData = file.file
    //   if (this.imgFormData) {
    //     this.isHideUploadIcon = true
    //     this.uploadImg('photo2')
    //   } else {
    //     this.$message.error(this.$t('sfe.notice.error.upload'))
    //     this.isHideUploadIcon = false
    //     this.imgFormData = null
    //   }
    // },
    // checkFile3(file, fileList) {
    //   this.imgFormData = file.file
    //   if (this.imgFormData) {
    //     this.isHideUploadIcon = true
    //     this.uploadImg('photo3')
    //   } else {
    //     this.$message.error(this.$t('sfe.notice.error.upload'))
    //     this.isHideUploadIcon = false
    //     this.imgFormData = null
    //   }
    // },
    // uploadImg(type) {
    //   const param = new FormData()
    //   const retailorStoreInfoPk = this.$route.query.retailorStoreInfoPk
    //   param.append('file', this.imgFormData)
    //   param.append('businessKey', retailorStoreInfoPk)
    //   param.append('resourceConfigFlag', 'sfe_store')
    //   this.isLoading = true
    //   this.$api.common
    //     .uploadFile(param)
    //     .then(res => {
    //       this.isLoading = false
    //       this.form[type] = res.data.url
    //       this.isHideUploadIcon = true
    //     })
    //     .catch(() => {
    //       this.isLoading = false
    //       this.fileList = []
    //       this.isHideUploadIcon = false
    //       this.imgFormData = null
    //       this.form.noticeImgOriginalUrl = ''
    //     })
    // },
    jump: function jump(domId) {
      var height = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var dom = document.getElementById(domId);
      // const domHeight = ((dom.offsetTop + 100) * 0.9).toFixed(2)
      var domHeight = ((dom.offsetTop + 100 - 90) * 1).toFixed(2);
      var S = Number(height) - Number(domHeight);
      if (S < 0) {
        S = Math.abs(S);
        window.scrollBy({
          top: S,
          behavior: 'smooth'
        });
      } else if (S === 0) {
        window.scrollBy({
          top: 0,
          behavior: 'smooth'
        });
      } else {
        S = -S;
        window.scrollBy({
          top: S,
          behavior: 'smooth'
        });
      }
    },
    resetError: function resetError(val) {
      if (val) {
        var index = this.errorKeys.indexOf(val);
        this.errorKeys.splice(index, 1);
        delete this.errorInfo.val;
      } else {
        this.errorKeys = [];
        this.errorInfo = {};
      }
    },
    // // 上传的图片格式限制
    // beforeAvatarUpload(file) {
    //   // const isLte = file.size / 1024 / 1024 < 1
    //   // if (!isLte) {
    //   //   this.$message.error('上传头像图片大小不能超过 1MB!')
    //   // }
    //   // return isLte
    //   return true
    // },
    edit: function edit(type) {
      if (type === 'view') {
        this.$set(this, 'type', 'edit');
      } else if (type === 'edit') {
        this.$set(this, 'type', 'view');
      }
    },
    // 零售店kpi查看
    salesKPIClick: function salesKPIClick() {
      var _this8 = this;
      if (!this.form.rtlSapId) {
        // 详情api都还没读取完
        return false;
      }
      this.isShowSalesKPI = true;
      this.$nextTick(function () {
        _this8.$refs['salesKPIRecord'].initEcharts();
      });
    },
    visitStoRecordClick: function visitStoRecordClick() {
      var _this9 = this;
      this.isShowVisitRecord = true;
      var retailorStoreInfoPk = this.$route.query.retailorStoreInfoPk;
      this.$nextTick(function () {
        _this9.$refs.visit.fetchData(retailorStoreInfoPk);
      });
    },
    trainRecordClick: function trainRecordClick() {
      var _this0 = this;
      this.isShowTrainingRecords = true;
      var retailorStoreInfoPk = this.$route.query.retailorStoreInfoPk;
      this.$nextTick(function () {
        _this0.$refs.training.fetchData(retailorStoreInfoPk);
      });
    },
    backList: function backList() {
      this.$router.go(-1);
    },
    // photoCloseClickHandle(name) {
    //   if (this.type === 'edit') {
    //     this.form[name] = ''
    //   }
    // },
    // handlePictureCardPreview(url) {
    //   this.dialogImageUrl = url
    //   this.dialogVisible = true
    // },
    trainingRecordsDataFetchHandle: function trainingRecordsDataFetchHandle(data) {
      this.trainingRecordsList = data;
    },
    visitRecordDataFetchHandle: function visitRecordDataFetchHandle(data) {
      this.visitRecordList = data;
    },
    productClick: function productClick() {
      this.isShowProductInfo = true;
      // this.$nextTick(() => {
      //   this.$refs.product.queryProductSelect()
      // })
    },
    productInfoDataFetchHandle: function productInfoDataFetchHandle() {}
  }
};